import { DialogueSlide } from '@/common/types/LectioTypes';

export class DialogueInstance {
  index: number;
  guardianChunkIndex: number;
  savedGuardianChunkIndex: number;
  slides: DialogueSlide[];
  hasEnded: boolean = false;

  constructor(slides: DialogueSlide[]) {
    this.index = -1;
    this.guardianChunkIndex = 0;
    this.slides = slides;
    this.savedGuardianChunkIndex = 0;
  }

  currentSlide = () => {
    return this.slides[this.index];
  };

  goToNextSlide = () => {
    this.index++;
    this.savedGuardianChunkIndex = this.guardianChunkIndex;
    if (this.index >= this.slides.length) {
      // Mark that we've reached the end of our dialogue.
      this.hasEnded = true;
    }
  };
}

export interface DynamicTextWrapper {
  textContainer: Phaser.GameObjects.Container;
  refText: Phaser.GameObjects.BitmapText;
  dynamicDialogueText: Phaser.GameObjects.DynamicBitmapText;
  generatedDialogueTexts: Phaser.GameObjects.DynamicBitmapText[];
  generatedUnderlines: Phaser.GameObjects.Graphics[];
  generatedPlaceholderIcons: Phaser.GameObjects.Image[];
}
